// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","197":"75fc9c18","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"85d9520dfe605ca322ea","197":"45ca0ce437bc1efd9430","293":"8d421c04cb32eb1f27de","522":"e9fb79faa67234c9ad5b"}[chunkId] + ".js";
};